import { createContext, useContext } from "react";

export type HandoffPhase = "boot" | "handoff" | "complete";

export interface HandoffPhaseContextValue {
  phase: HandoffPhase;
}

export const HandoffPhaseContext = createContext<HandoffPhaseContextValue>({
  phase: "complete",
});

export const useHandoffPhase = () => useContext(HandoffPhaseContext);

export const useIsHandoffComplete = () => {
  const { phase } = useHandoffPhase();
  return phase === "complete";
};
